import { render, staticRenderFns } from "./messageText.vue?vue&type=template&id=a667522a&scoped=true"
import script from "./messageText.vue?vue&type=script&lang=js"
export * from "./messageText.vue?vue&type=script&lang=js"
import style0 from "./messageText.vue?vue&type=style&index=0&id=a667522a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a667522a",
  null
  
)

export default component.exports